module.exports = __webpack_public_path__ + "img/economia_circular_link.51e82f74.png";